/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddBiensToParcCommand
 */
export interface AddBiensToParcCommand {
    /**
     * Identifiants des biens à rattacher au parc (ajout en lot)
     * @type {Array<string>}
     * @memberof AddBiensToParcCommand
     */
    realEstateIds: Array<string>;
}

/**
 * Check if a given object implements the AddBiensToParcCommand interface.
 */
export function instanceOfAddBiensToParcCommand(value: object): value is AddBiensToParcCommand {
    if (!('realEstateIds' in value) || value['realEstateIds'] === undefined) return false;
    return true;
}

export function AddBiensToParcCommandFromJSON(json: any): AddBiensToParcCommand {
    return AddBiensToParcCommandFromJSONTyped(json, false);
}

export function AddBiensToParcCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddBiensToParcCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'realEstateIds': json['realEstateIds'],
    };
}

export function AddBiensToParcCommandToJSON(json: any): AddBiensToParcCommand {
    return AddBiensToParcCommandToJSONTyped(json, false);
}

export function AddBiensToParcCommandToJSONTyped(value?: AddBiensToParcCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'realEstateIds': value['realEstateIds'],
    };
}

